module.exports = __webpack_public_path__ + "img/img17.7aa8921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img17.png
// module id = 257
// module chunks = 0